import { render, staticRenderFns } from "./ProductContainer.vue?vue&type=template&id=01d8fee1&scoped=true"
import script from "./ProductContainer.vue?vue&type=script&lang=ts"
export * from "./ProductContainer.vue?vue&type=script&lang=ts"
import style0 from "./ProductContainer.vue?vue&type=style&index=0&id=01d8fee1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8fee1",
  null
  
)

export default component.exports